module.exports = __webpack_public_path__ + "images/embed/search_bg.gif";